/* @flow */
import React from 'react';
import { Route } from 'react-router-dom';
import { translate } from 'react-i18next';

import withRouteTracker from 'common/middleware/RouteTracker';
import { Title } from 'common/components/common';
import Products from 'common/enums/Product';
import { lazy } from 'common/modules/mfe';

import SectionWrap from 'common/components/common/SectionWrap';
import { type GetRoutesFn } from './types';

const QuotationsContainer = lazy(() =>
    import('orderiq-app/QuotationsContainer')
);
const TrackedQuotationsSection = withRouteTracker(
    translate()(props => {
        return (
            <SectionWrap>
                <Title i18nKey="quotationsDashboard" />
                <QuotationsContainer {...props} />
            </SectionWrap>
        );
    }),
    Products.ORCHESTRATOR
);

const OrderRoutesContainer = lazy(() =>
    import('orderiq-app/OrderRoutesContainer')
);
const TrackedOrdersSection = withRouteTracker(
    translate()(props => {
        return (
            <SectionWrap>
                <Title i18nKey="ordersDashboard" />
                <OrderRoutesContainer {...props} />
            </SectionWrap>
        );
    }),
    Products.ORCHESTRATOR
);

const TourManagementContainer = lazy(() =>
    import('orderiq-app/TourManagementContainer')
);
const TrackedTourManagementSection = withRouteTracker(
    translate()(props => {
        return (
            <SectionWrap>
                <Title i18nKey="tourManagementDashboard" />
                <TourManagementContainer {...props} />
            </SectionWrap>
        );
    }),
    Products.ORCHESTRATOR
);

const getRoutes: GetRoutesFn = ({ match, visibleSections }) => {
    return [
        visibleSections.showQuoteManagementSection && (
            <Route
                path={`${match.path}/quotations`}
                component={TrackedQuotationsSection}
            />
        ),

        visibleSections.showOrderManagementSection && (
            <Route
                path={`${match.path}/orders`}
                component={TrackedOrdersSection}
            />
        ),

        visibleSections.showTourDispatchManagementSection && (
            <Route
                path={`${match.path}/tours`}
                component={TrackedTourManagementSection}
            />
        )
    ].filter(Boolean);
};

export default getRoutes;
